import React, { PropsWithChildren } from 'react'

const Spacer: React.FC<PropsWithChildren<{}>> = (props: PropsWithChildren<{}>) => (
  <div className='vertical-center-container align-center' style={{ height: 'calc(100vh - 300px)' }}>
    <div className='vertical-center inline-block'>{props.children}</div>
  </div>
)
export default Spacer
